import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import withMobileDialog from '@material-ui/core/withMobileDialog';

class NoCreditDialog extends React.Component {

  handleClose = () => {
    const { close } = this.props
    close()
  };

  render() {
    const { open } = this.props;

    return (


        <Dialog
          fullScreen={false}
          open={open}
          onClose={this.handleClose}
          aria-labelledby="responsive-dialog-title"
        >
          <DialogTitle id="responsive-dialog-title">{"Campaign Error"}</DialogTitle>
          <DialogContent>
            <DialogContentText>
            There was an error processing your campaign.  Please try again or contact support@sonicleads.com if the problem persists.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} color="primary" autoFocus>
              Ok
            </Button>
          </DialogActions>
        </Dialog>

    );
  }
}

NoCreditDialog.propTypes = {
  fullScreen: PropTypes.bool.isRequired,
};

export default withMobileDialog()(NoCreditDialog);


// WEBPACK FOOTER //
// ./src/components/Leads/Campaigns/ManageCampaign/Options/Dialogs/CampiagnFailureDialog.js